import { SignUpContainer } from "Containers/AuthContainer/SignUpContainer/SignUpContainer";

export const SignUp = () => {
  return <SignUpContainer />;
};
